import React, { Component } from 'react';
import styled from 'styled-components';
import TeamHeader from './TeamHeader';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

const Content = styled.div`
    margin-top: 30px;
`;

class TeamHostSMB extends Component {
    state = {
        teamId: (this.props.params && this.props.params.teamId) || '',
        team: {},
        tournaments: [],
        tournamentIds: []
    };

    componentDidMount() {
        this.loadData(this.props.params);
    }

    componentWillReceiveProps({ params }) {
        if (params.teamId !== this.state.teamId) {
            this.loadData(params);
        }
    }

    loadData({ teamId = '' }) {
        fetch(`http://ss2.si-ab.com/teams/${teamId}/`)
            .then(res => res.json())
            .then(team => {
                if (team) {
                    return Promise.all(
                        team.tournamentTemplateId.map(id =>
                            fetch(`http://ss2.si-ab.com/tournaments/${id}`).then(res => res.json())
                        )
                    ).then(tournaments => {
                        if (tournaments) {
                            this.setState({
                                teamId,
                                team,
                                tournaments,
                                tournamentIds: team.tournamentTemplateId
                            });
                        }
                    });
                }
            });
    }

    render() {
        const { teamId = '', team = {}, tournaments = [], tournamentIds = [] } = this.state;
        const { tournamentId = '', seasonId = '' } = this.props.params;

        if (!tournamentIds.find(id => id === ~~tournamentId) && tournaments[0]) {
            browserHistory.push({
                pathname: location.pathname.replace(
                    new RegExp('tournaments\\/\\d*\\/\\d*'),
                    `tournaments/${tournaments[0].id}/${tournaments[0].currentSeason.id}`
                )
            });
        }

        return (
            <Content>
                <TeamHeader
                    teamId={teamId}
                    team={team}
                    tournamentId={tournamentId}
                    seasonId={seasonId}
                    tournaments={tournaments}
                />
                {this.props.children}
            </Content>
        );
    }
}

TeamHostSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.any
};

export default TeamHostSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TeamHostSMB.js
 **/